/**
 * Utility function to translate role names from database to the current language
 */

// Map of DB role names to translation keys
const roleTranslationKeys = {
    'Човешки Ресурси': 'humanResources',
    Счетоводство: 'accounting',
    Анализатор: 'analyst',
    Администратор: 'administrator',
};

/**
 * Translates a role name from the database to the current language
 * @param {string} dbRoleName - The role name from the database
 * @param {function} t - The translation function from react-i18next
 * @returns {string} - The translated role name
 */
export const translateRole = (dbRoleName, t) => {
    const key = roleTranslationKeys[dbRoleName];
    if (key) {
        return t(`systemAdmin.roles.${key}`);
    }
    return dbRoleName; // Return the original name if no mapping is found
};

export default translateRole;
